import React, { Component } from 'react';
import { Card, Button, CardHeader, CardBody, Label, Table, Progress, Row, Col, FormGroup, Input, FormFeedback, Alert } from 'reactstrap';
import { FaPlusCircle } from 'react-icons/fa';
import FaTrash from "../../imgs/deleteIcon.png"
import FaPencilAlt from "../../imgs/lapiz.svg"
import MensajeModal from "../MensajeModal"
import { OBTENER_URL_SERVICIO } from "../../constants/action-types";
import axios from "axios";
import Timer from "react-time-counter";

//import DataJson from './clienteJson';

class TableCliente extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modalEstado: false,
            modalTitulo: "",
            modalMensaje: "",
            modalFooter: "",
            datosTraidos: [],

            modalCedula: "",
            modalNombre: "",
            modalApellido: "",
            modalCorreo: "",
            invalid1: false,
            invalid2: false,
            invalid3: false,
            invalid4: false,
        };
        this.toggle = this.toggle.bind(this);
        this.modalNuevo = this.modalNuevo.bind(this);
        this.modalEditar = this.modalEditar.bind(this);
        this.modalEliminar = this.modalEliminar.bind(this);
        this.buscarDatos = this.buscarDatos.bind(this);
        this.borrarSeleccion = this.borrarSeleccion.bind(this);
        this.editarSeleccion = this.editarSeleccion.bind(this);
        this.agregarDato = this.agregarDato.bind(this);
        this.handleChangeModal = this.handleChangeModal.bind(this);
    }

    toggle() {
        this.setState({
            modalEstado: !this.state.modalEstado
        });
    }

    async handleChangeModal(e) {
        const idVariable = e.target.name;
        switch (idVariable) {
            case "modalCedula":
                if (e.target.value.length <= 10) {
                    await this.setState({
                        modalCedula: e.target.value
                    })
                    this.setState({
                        modalMensaje:
                            <Row>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                                    <center>
                                        <Label>Por favor ingresa los datos a modificar:</Label>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Cédula</Label>
                                            <Input invalid={this.state.invalid1} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalCedula} bsSize="sm" type="text" name="modalCedula" id="modalCedula" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 10 Números</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Nombre</Label>
                                            <Input invalid={this.state.invalid2} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalNombre} bsSize="sm" type="text" name="modalNombre" id="modalNombre" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Apellido</Label>
                                            <Input invalid={this.state.invalid3} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalApellido} bsSize="sm" type="text" name="modalApellido" id="modalApellido" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Correo</Label>
                                            <Input invalid={this.state.invalid4} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalCorreo} bsSize="sm" type="text" name="modalCorreo" id="modalCorreo" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 64 Caracteres, debe ser "@konradlorenz.edu.co"</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                            </Row>,
                    })
                }
                break;
            case "modalNombre":
                if (e.target.value.length <= 80) { //PASO 32 A 80
                    await this.setState({
                        modalNombre: e.target.value
                    })
                    this.setState({
                        modalMensaje:
                            <Row>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                                    <center>
                                        <Label>Por favor ingresa los datos a modificar:</Label>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Cédula</Label>
                                            <Input invalid={this.state.invalid1} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalCedula} bsSize="sm" type="text" name="modalCedula" id="modalCedula" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 10 Números</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Nombre</Label>
                                            <Input invalid={this.state.invalid2} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalNombre} bsSize="sm" type="text" name="modalNombre" id="modalNombre" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Apellido</Label>
                                            <Input invalid={this.state.invalid3} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalApellido} bsSize="sm" type="text" name="modalApellido" id="modalApellido" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Correo</Label>
                                            <Input invalid={this.state.invalid4} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalCorreo} bsSize="sm" type="text" name="modalCorreo" id="modalCorreo" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 64 Caracteres, debe ser "@konradlorenz.edu.co"</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                            </Row>,
                    })
                }
                break;
            case "modalApellido":
                if (e.target.value.length <= 80) { //PASO 32 A 80
                    await this.setState({
                        modalApellido: e.target.value
                    })
                    this.setState({
                        modalMensaje:
                            <Row>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                                    <center>
                                        <Label>Por favor ingresa los datos a modificar:</Label>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Cédula</Label>
                                            <Input invalid={this.state.invalid1} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalCedula} bsSize="sm" type="text" name="modalCedula" id="modalCedula" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 10 Números</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Nombre</Label>
                                            <Input invalid={this.state.invalid2} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalNombre} bsSize="sm" type="text" name="modalNombre" id="modalNombre" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Apellido</Label>
                                            <Input invalid={this.state.invalid3} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalApellido} bsSize="sm" type="text" name="modalApellido" id="modalApellido" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Correo</Label>
                                            <Input invalid={this.state.invalid4} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalCorreo} bsSize="sm" type="text" name="modalCorreo" id="modalCorreo" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 64 Caracteres, debe ser "@konradlorenz.edu.co"</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                            </Row>,
                    })
                }
                break;
            case "modalCorreo":
                if (e.target.value.length <= 64) {
                    await this.setState({
                        modalCorreo: e.target.value
                    })
                    this.setState({
                        modalMensaje:
                            <Row>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                                    <center>
                                        <Label>Por favor ingresa los datos a modificar:</Label>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Cédula</Label>
                                            <Input invalid={this.state.invalid1} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalCedula} bsSize="sm" type="text" name="modalCedula" id="modalCedula" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 10 Números</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Nombre</Label>
                                            <Input invalid={this.state.invalid2} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalNombre} bsSize="sm" type="text" name="modalNombre" id="modalNombre" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Apellido</Label>
                                            <Input invalid={this.state.invalid3} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalApellido} bsSize="sm" type="text" name="modalApellido" id="modalApellido" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Correo</Label>
                                            <Input invalid={this.state.invalid4} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalCorreo} bsSize="sm" type="text" name="modalCorreo" id="modalCorreo" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 64 Caracteres, debe ser "@konradlorenz.edu.co"</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                            </Row>,
                    })
                }
                break;
            default:
                break;
        }
    }

    async componentDidMount() {
        this.setState({
            modalTitulo: "Cargando",
            modalMensaje:
                <div>
                    <p>Estamos buscando las áreas existentes, ¡Por favor espera!</p>
                </div>,
            modalFooter: <div style={{ width: "100%" }}>
                <Progress animated color="success" value="100" />
            </div>
        })
        this.toggle();
        await this.buscarDatos(true);
    }

    async buscarDatos(bool) {


        try {
            const response = await axios.get(OBTENER_URL_SERVICIO + "/clientes");
            //const response = { DataJson }
            await this.setState({
                datosTraidos: response.data
                //datosTraidos: response.DataJson
            })
            if (bool === true) {
                this.toggle();
            }
        }
        catch{
            await this.setState({
                datosTraidos: ""
            })

            if (bool === true) {
                this.toggle();
            }
        }

    }

    async modalNuevo() {
        await this.setState({
            auxID: 999,
            invalid1: false,
            invalid2: false,
            invalid3: false,
            invalid4: false,
            modalCedula: "",
            modalNombre: "",
            modalApellido: "",
            modalCorreo: "",
        })

        this.setState({
            invalid1: false,
            invalid2: false,
            invalid3: false,
            invalid4: false,
            modalCedula: "",
            modalNombre: "",
            modalApellido: "",
            modalCorreo: "",
            modalTitulo: "Agregar",
            modalMensaje:
                <Row>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                        <center>
                            <Label>Por favor ingresa los datos a modificar:</Label>
                        </center>
                    </Col>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                        <center>
                            <FormGroup>
                                <Label for="exampleEmail">Cédula</Label>
                                <Input invalid={this.state.invalid1} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalCedula} bsSize="sm" type="text" name="modalCedula" id="modalCedula" onChange={this.handleChangeModal} />
                                <FormFeedback tooltip>De 2 a 10 Números</FormFeedback>
                            </FormGroup>
                        </center>
                    </Col>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                        <center>
                            <FormGroup>
                                <Label for="exampleEmail">Nombre</Label>
                                <Input invalid={this.state.invalid2} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalNombre} bsSize="sm" type="text" name="modalNombre" id="modalNombre" onChange={this.handleChangeModal} />
                                <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                            </FormGroup>
                        </center>
                    </Col>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                        <center>
                            <FormGroup>
                                <Label for="exampleEmail">Apellido</Label>
                                <Input invalid={this.state.invalid3} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalApellido} bsSize="sm" type="text" name="modalApellido" id="modalApellido" onChange={this.handleChangeModal} />
                                <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                            </FormGroup>
                        </center>
                    </Col>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                        <center>
                            <FormGroup>
                                <Label for="exampleEmail">Correo</Label>
                                <Input invalid={this.state.invalid4} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalCorreo} bsSize="sm" type="text" name="modalCorreo" id="modalCorreo" onChange={this.handleChangeModal} />
                                <FormFeedback tooltip>De 2 a 64 Caracteres, debe ser "@konradlorenz.edu.co"</FormFeedback>
                            </FormGroup>
                        </center>
                    </Col>
                </Row>,
            modalFooter: <div>
                <Button color="secondary" onClick={this.toggle}>Cancelar</Button>{' '}
                <Button onClick={this.agregarDato} color="success">Agregar</Button>
            </div>
        })
        this.toggle();
    }
    async agregarDato() {
        var hayError = false;
        var regexNumber = /^[0-9]+$/;
        //var regexString = /^[a-zA-Z]+$/;
        if (!this.state.modalCedula.match(regexNumber) || this.state.modalCedula === undefined || this.state.modalCedula === "" || this.state.modalCedula === null || this.state.modalCedula.length <= 1 || this.state.modalCedula.length >= 11) {
            hayError = true;
            this.setState({
                invalid1: true,
            })
        } else {
            this.setState({
                invalid1: false,
            })
        }
        if (this.state.modalNombre === undefined || this.state.modalNombre === "" || this.state.modalNombre === null || this.state.modalNombre.length < 1 || this.state.modalNombre.length >= 81) { // PASO 33 A 81
            hayError = true;
            this.setState({
                invalid2: true,
            })
        } else {
            this.setState({
                invalid2: false,
            })
        }
        if (this.state.modalApellido === undefined || this.state.modalApellido === "" || this.state.modalApellido === null || this.state.modalApellido.length < 1 || this.state.modalApellido.length >= 81) { //PASO 33 A 81
            hayError = true;
            this.setState({
                invalid3: true,
            })
        } else {
            this.setState({
                invalid3: false,
            })
        }
        if (!this.state.modalCorreo.includes("@konradlorenz.edu.co") || this.state.modalCorreo === undefined || this.state.modalCorreo === "" || this.state.modalCorreo === null || this.state.modalCorreo.length < 1 || this.state.modalCorreo.length >= 65) {
            hayError = true;
            this.setState({
                invalid4: true,
            })
        } else {
            this.setState({
                invalid4: false,
            })
        }
        if (hayError === true) {
            setTimeout(
                function () {
                    this.setState({
                        modalMensaje:
                            <Row>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                                    <center>
                                        <Label>Por favor ingresa los datos a modificar:</Label>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Cédula</Label>
                                            <Input invalid={this.state.invalid1} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalCedula} bsSize="sm" type="text" name="modalCedula" id="modalCedula" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 10 Números</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Nombre</Label>
                                            <Input invalid={this.state.invalid2} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalNombre} bsSize="sm" type="text" name="modalNombre" id="modalNombre" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Apellido</Label>
                                            <Input invalid={this.state.invalid3} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalApellido} bsSize="sm" type="text" name="modalApellido" id="modalApellido" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Correo</Label>
                                            <Input invalid={this.state.invalid4} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalCorreo} bsSize="sm" type="text" name="modalCorreo" id="modalCorreo" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 64 Caracteres, debe ser "@konradlorenz.edu.co"</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                            </Row>,
                    })
                    return null;
                }
                    .bind(this),
                10
            );
        } else {
            this.setState({
                modalTitulo: "Procesando",
                modalMensaje:
                    <div>
                        <p>¡Estamos procesando la acción, espera por favor!</p>
                    </div>,
                modalFooter: <div style={{ width: "100%" }}>
                    <Progress animated color="success" value="100" />
                </div>
            })
            var envioDatos = {
                clienteCedulaP: this.state.modalCedula,
                namCliente: this.state.modalNombre,
                apellidoCliente: this.state.modalApellido,
                correoCliente: this.state.modalCorreo,
            }
            try {
                const response = await axios.post(OBTENER_URL_SERVICIO + "/cliente/new", envioDatos);
                if (response.data.tipo === "EXITO") {
                    this.setState({
                        modalTitulo: "Exito",
                        modalMensaje:
                            <div>
                                <p>¡Dato agregado!</p>
                            </div>,
                        modalFooter: <div>
                            <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                        </div>
                    })
                } else {
                    if (response.data.tipo === "ERROR") {
                        this.setState({
                            modalTitulo: "Error",
                            modalMensaje:
                                <div>
                                    <p>No se puede procesar la acción, intenta de nuevo más tarde.</p>
                                </div>,
                            modalFooter: <div>
                                <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                            </div>
                        })
                    } else {
                        this.setState({
                            modalTitulo: "Error",
                            modalMensaje:
                                <div>
                                    <p>No se puede procesar la acción, intenta de nuevo más tarde.</p>
                                </div>,
                            modalFooter: <div>
                                <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                            </div>
                        })
                    }
                }
                this.buscarDatos(false)
            }
            catch (error) {
                this.setState({
                    modalTitulo: "Error",
                    modalMensaje:
                        <div>
                            <center>
                                <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde. (500 Error)</p>
                            </center>
                        </div>,
                    modalFooter: <div style={{ width: "100%" }}>
                        <center>
                            <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
                        </center>
                    </div>,
                })
                setTimeout(
                    function () {
                        this.toggle();
                    }
                        .bind(this),
                    5000
                );
            }
        }
    }

    async modalEditar(event) {
        const datos = event.target.id;
        const arrayDatos = datos.split("///");
        await this.setState({
            auxID: arrayDatos[0],
            modalCedula: arrayDatos[0],
            modalNombre: arrayDatos[1],
            modalApellido: arrayDatos[2],
            modalCorreo: arrayDatos[3]
        })
        this.setState({
            invalid1: false,
            invalid2: false,
            modalTitulo: "Editar",
            modalMensaje:
                <Row>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                        <center>
                            <Label>Por favor ingresa los datos a modificar:</Label>
                        </center>
                    </Col>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                        <center>
                            <FormGroup>
                                <Label for="exampleEmail">Cédula</Label>
                                <Input invalid={this.state.invalid1} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalCedula} bsSize="sm" type="text" name="modalCedula" id="modalCedula" onChange={this.handleChangeModal} />
                                <FormFeedback tooltip>De 2 a 10 Números</FormFeedback>
                            </FormGroup>
                        </center>
                    </Col>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                        <center>
                            <FormGroup>
                                <Label for="exampleEmail">Nombre</Label>
                                <Input invalid={this.state.invalid2} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalNombre} bsSize="sm" type="text" name="modalNombre" id="modalNombre" onChange={this.handleChangeModal} />
                                <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                            </FormGroup>
                        </center>
                    </Col>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                        <center>
                            <FormGroup>
                                <Label for="exampleEmail">Apellido</Label>
                                <Input invalid={this.state.invalid3} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalApellido} bsSize="sm" type="text" name="modalApellido" id="modalApellido" onChange={this.handleChangeModal} />
                                <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                            </FormGroup>
                        </center>
                    </Col>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                        <center>
                            <FormGroup>
                                <Label for="exampleEmail">Correo</Label>
                                <Input invalid={this.state.invalid4} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalCorreo} bsSize="sm" type="text" name="modalCorreo" id="modalCorreo" onChange={this.handleChangeModal} />
                                <FormFeedback tooltip>De 2 a 64 Caracteres, debe ser "@konradlorenz.edu.co"</FormFeedback>
                            </FormGroup>
                        </center>
                    </Col>
                </Row>,
            modalFooter: <div>
                <Button color="secondary" onClick={this.toggle}>Cancelar</Button>{' '}
                <Button onClick={this.editarSeleccion} color="warning">Editar</Button>
            </div>
        })
        this.toggle();
    }
    async editarSeleccion() {
        var hayError = false;
        var regexNumber = /^[0-9]+$/;
        //var regexString = /^[a-zA-Z]+$/;
        if (!this.state.modalCedula.match(regexNumber) || this.state.modalCedula === undefined || this.state.modalCedula === "" || this.state.modalCedula === null || this.state.modalCedula.length <= 1 || this.state.modalCedula.length >= 11) {
            hayError = true;
            this.setState({
                invalid1: true,
            })
        } else {
            this.setState({
                invalid1: false,
            })
        }
        if (this.state.modalNombre === undefined || this.state.modalNombre === "" || this.state.modalNombre === null || this.state.modalNombre.length < 1 || this.state.modalNombre.length >= 81) { //PASO 33 A 81
            hayError = true;
            this.setState({
                invalid2: true,
            })
        } else {
            this.setState({
                invalid2: false,
            })
        }
        if (this.state.modalApellido === undefined || this.state.modalApellido === "" || this.state.modalApellido === null || this.state.modalApellido.length < 1 || this.state.modalApellido.length >= 81) { // PASO 33 A 81
            hayError = true;
            this.setState({
                invalid3: true,
            })
        } else {
            this.setState({
                invalid3: false,
            })
        }
        if (!this.state.modalCorreo.includes("@konradlorenz.edu.co") || this.state.modalCorreo === undefined || this.state.modalCorreo === "" || this.state.modalCorreo === null || this.state.modalCorreo.length < 1 || this.state.modalCorreo.length >= 65) {
            hayError = true;
            this.setState({
                invalid4: true,
            })
        } else {
            this.setState({
                invalid4: false,
            })
        }
        if (hayError === true) {
            setTimeout(
                function () {
                    this.setState({
                        modalMensaje:
                            <Row>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                                    <center>
                                        <Label>Por favor ingresa los datos a modificar:</Label>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Cédula</Label>
                                            <Input invalid={this.state.invalid1} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalCedula} bsSize="sm" type="text" name="modalCedula" id="modalCedula" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 10 Números</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Nombre</Label>
                                            <Input invalid={this.state.invalid2} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalNombre} bsSize="sm" type="text" name="modalNombre" id="modalNombre" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Apellido</Label>
                                            <Input invalid={this.state.invalid3} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalApellido} bsSize="sm" type="text" name="modalApellido" id="modalApellido" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Correo</Label>
                                            <Input invalid={this.state.invalid4} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalCorreo} bsSize="sm" type="text" name="modalCorreo" id="modalCorreo" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 64 Caracteres, debe ser "@konradlorenz.edu.co"</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                            </Row>,
                    })
                    return null;
                }
                    .bind(this),
                10
            );
        } else {
            this.setState({
                modalTitulo: "Procesando",
                modalMensaje:
                    <div>
                        <p>¡Estamos procesando la acción, espera por favor!</p>
                    </div>,
                modalFooter: <div style={{ width: "100%" }}>
                    <Progress animated color="success" value="100" />
                </div>
            })
            var envioDatos = {
                clienteCedulaP: this.state.modalCedula,
                namCliente: this.state.modalNombre,
                apellidoCliente: this.state.modalApellido,
                correoCliente: this.state.modalCorreo,
            }
            try {
                const response = await axios.put(OBTENER_URL_SERVICIO + "/cliente/" + this.state.auxID, envioDatos);
                if (response.data.tipo === "Actualizado") {
                    this.setState({
                        modalTitulo: "Actualizado",
                        modalMensaje:
                            <div>
                                <p>¡Cliente actualizado con éxito!</p>
                            </div>,
                        modalFooter: <div>
                            <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                        </div>
                    })
                } else {
                    if (response.data.tipo === "Error") {
                        this.setState({
                            modalTitulo: "Area no encontrada",
                            modalMensaje:
                                <div>
                                    <p>No se encontró el cliente para eliminar.</p>
                                    <p>¡Quizás alguien se adelantó!</p>
                                </div>,
                            modalFooter: <div>
                                <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                            </div>
                        })
                    } else {
                        this.setState({
                            modalTitulo: "Error",
                            modalMensaje:
                                <div>
                                    <p>No se puede procesar la acción, intenta de nuevo más tarde.</p>
                                </div>,
                            modalFooter: <div>
                                <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                            </div>
                        })
                    }
                }
                this.buscarDatos(false)
            }
            catch (error) {
                this.setState({
                    modalTitulo: "Error",
                    modalMensaje:
                        <div>
                            <center>
                                <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde. (500 Error)</p>
                            </center>
                        </div>,
                    modalFooter: <div style={{ width: "100%" }}>
                        <center>
                            <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
                        </center>
                    </div>,
                })
                setTimeout(
                    function () {
                        this.toggle();
                    }
                        .bind(this),
                    5000
                );
            }
        }
    }

    modalEliminar(event) {
        this.setState({
            modalTitulo: "Eliminar",
            modalMensaje:
                <Row>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                        <center>
                            <Label>¡ATENCIÓN!</Label>
                            <br />
                            <Label>Se eliminará el dato seleccionado.</Label>
                        </center>
                    </Col>
                </Row>,
            modalFooter: <div>
                <Button color="secondary" onClick={this.toggle}>Cancelar</Button>{' '}
                <Button id={event.target.id} onClick={this.borrarSeleccion} color="danger">Eliminar</Button>
            </div>
        })
        this.toggle();
    }
    async borrarSeleccion(event) {
        this.setState({
            modalTitulo: "Procesando",
            modalMensaje:
                <div>
                    <p>¡Estamos procesando la acción, espera por favor!</p>
                </div>,
            modalFooter: <div style={{ width: "100%" }}>
                <Progress animated color="success" value="100" />
            </div>
        })
        try {
            const response = await axios.delete(OBTENER_URL_SERVICIO + "/cliente/" + event.target.id);
            if (response.data.tipo === "EXITO") {
                this.setState({
                    modalTitulo: "EXITO",
                    modalMensaje:
                        <div>
                            <p>¡Cliente eliminado con éxito!</p>
                        </div>,
                    modalFooter: <div>
                        <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                    </div>
                })
            } else {
                if (response.data.tipo === "NO ENCONTRADO") {
                    this.setState({
                        modalTitulo: "Area no encontrada",
                        modalMensaje:
                            <div>
                                <p>No se encontró el área para eliminar.</p>
                                <p>¡Quizás alguien se adelantó!</p>
                            </div>,
                        modalFooter: <div>
                            <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                        </div>
                    })
                } else {
                    this.setState({
                        modalTitulo: "Error",
                        modalMensaje:
                            <div>
                                <p>Por favor, valida que el área no contenga agentes o módulos.</p>
                            </div>,
                        modalFooter: <div>
                            <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                        </div>
                    })
                }
            }
            this.buscarDatos(false)
        }
        catch (error) {
            this.setState({
                modalTitulo: "Error",
                modalMensaje:
                    <div>
                        <center>
                            <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde. (500 Error)</p>
                        </center>
                    </div>,
                modalFooter: <div style={{ width: "100%" }}>
                    <center>
                        <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
                    </center>
                </div>,
            })
            setTimeout(
                function () {
                    this.toggle();
                }
                    .bind(this),
                5000
            );
        }

    }

    render() {
        var datosTabla =
            <Alert color="primary">
                No hay Clientes inscritos.
    </Alert>

        if (this.state.datosTraidos !== null && this.state.datosTraidos !== undefined && this.state.datosTraidos.length > 0) {
            datosTabla =
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>Cedula</th>
                            <th>Nombre</th>
                            <th>Apellido</th>
                            <th>Correo</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.datosTraidos.map(p => {
                            return (
                                <tr key={p.clienteCedulaP}>
                                    <th scope="row">{p.clienteCedulaP}</th>
                                    <td>{p.namCliente}</td>
                                    <td>{p.apellidoCliente}</td>
                                    <td>{p.correoCliente}</td>
                                    <td><Button size="sm" color="warning" id={p.clienteCedulaP + "///" + p.namCliente + "///" + p.apellidoCliente + "///" + p.correoCliente} onClick={this.modalEditar} ><img style={{ verticalAlign: "middle" }} height="15" src={FaPencilAlt} id={p.clienteCedulaP + "///" + p.namCliente + "///" + p.apellidoCliente + "///" + p.correoCliente} alt="editar" /></Button>{" | | "}<Button size="sm" color="danger" id={p.clienteCedulaP} onClick={this.modalEliminar} ><img style={{ verticalAlign: "middle" }} height="15" src={FaTrash} id={p.clienteCedulaP} alt="borrar" /></Button></td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
        }

        return (
            <div>
                <MensajeModal modal={this.state.modalEstado} titulo={this.state.modalTitulo} toggle={this.toggle} mensaje={this.state.modalMensaje} footer={this.state.modalFooter} ></MensajeModal>
                <CardBody>
                    <Card>
                        <CardHeader style={{ backgroundColor: "#c0d6e4" }}> <Label style={{ color: "black", fontSize: "25px" }}>Gestionar Clientes </Label> <Button className="btn btn-success float-right" onClick={this.modalNuevo}><FaPlusCircle></FaPlusCircle> Agregar Clientes</Button></CardHeader>
                        <CardBody>
                            {datosTabla}
                        </CardBody>
                    </Card>
                </CardBody>
            </div>
        );
    }
}

export default TableCliente;